import React, { Component } from "react";
import {
  FaTwitter,
  FaFacebookSquare,
  FaYoutube,
  FaInstagram,
  FaPhone,
  FaLinkedin,
} from "react-icons/fa";
// import logo from "../../assets/logo.png";
import logo from "../../assets/Fav Icon.png";
import localization from "../../Localization/Localization.json";

import { Link } from "react-router-dom";
// import {
//   FacebookIcon,
//   InstagramIcon,
//   LinkedinIcon,
//   LocationIcon,
//   MailIcon,
//   PhoneIcon,
//   TwitterIcon,
// } from "../../assets/images/svgs";
import "./FooterWide.scss";
import { Button } from "antd";
import { FiPhoneForwarded } from "react-icons/fi";
import { AiFillMail } from "react-icons/ai";
import { MdLocationOn } from "react-icons/md";

export default function FooterWide() {
  const socialLinks = {
    facebook: "",
    linkedin: "",
    twitter: "",
    instagram: "",
  };
  const navLinks = [
    {
      lable: "Home",
      path: "home",
    },
    {
      lable: "About us",
      path: "about",
    },
    {
      lable: "Features",
      path: "features",
    },
    {
      lable: "Contact us",
      path: "contact-us",
    },
  ];

  const contactus = {
    address: {
      url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d75483.12577438382!2d46.642141978926944!3d24.712662664514667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f03890d489399%3A0xba974d1c98e79fd5!2sRiyadh%20Saudi%20Arabia!5e0!3m2!1sen!2seg!4v1683620649222!5m2!1sen!2seg",
      lable: {
        en: "Riyadh, Saudi Arabia",
        ar: "الرياض، المملكة العربية السعودية",
      },
    },
    email: "info@mycar-sa.com",
    phone: "+966 54 044 6061",
  };
  const currentLang = "ar";
  return (
    <footer className="footer-wide-wrapper">
      <div className="container">
        <div className="footer-wide-content">
          <div className="footer-col-1">
            <Link to="/">
              <img className="" src={logo} alt="My car" />
            </Link>
            <p className="footer-col-1__desc">
              MyCar هو تطبيق يهدف إلى تسهيل وتحسين تجربة شراء وتمويل السيارات
              عبر الإنترنت
            </p>
            <div className="footer-col-1__links">
              <a href={socialLinks.facebook}>
                <Button
                  type="primary"
                  ghost
                  icon={<FaFacebookSquare className="inline w-6" />}
                />
              </a>
              {/* <a href={socialLinks.linkedin}>
                  <Button
                    type="primary"
                    ghost
                    icon={<LinkedinIcon className="inline w-6" />}
                    
                  />
                </a> */}
              <a href={socialLinks.twitter}>
                <Button
                  type="primary"
                  ghost
                  icon={<FaTwitter className="inline w-6" />}
                />
              </a>
              <a href={socialLinks.instagram}>
                <Button
                  type="primary"
                  ghost
                  icon={<FaInstagram className="inline w-6" />}
                />
              </a>
              <a href={socialLinks.linkedin}>
                <Button
                  type="primary"
                  ghost
                  icon={<FaLinkedin className="inline w-6" />}
                />
              </a>
            </div>
          </div>

          <div className="footer-col-2">
            <h4>Quick Links</h4>
            <div className="grid grid-cols-2">
              <ul className="space-y-6">
                <li>
                  <Link
                    exact
                    to="/"
                    activeClassName="activee"
                    className="glo-link-style-footer"
                  >
                    {localization.home[currentLang]}
                  </Link>
                </li>
                <li>
                  <a href="#app-section" className="glo-link-style-footer">
                    عن التطبيق
                  </a>
                </li>
                <li>
                  <a href="#brand-section" className="glo-link-style-footer">
                    {localization.gallary[currentLang]}
                  </a>
                </li>
                {/* <li>
                  <a href="#service-section">
                    {" "}
                    {localization.services[currentLang]}{" "}
                  </a>
                </li>
                <li>
                  <a href="#advantages-section">الميزات</a>
                </li> */}
                <li>
                  <a href="#contact-section" className="glo-link-style-footer">
                    {" "}
                    {localization.contactUs[currentLang]}
                  </a>
                </li>

                {/* {navLinks.map((link, i) => (
                  <li key={i}>
                    <Link to={link?.path} className="glo-link-style-footer">
                      {link?.lable}
                    </Link>
                  </li>
                ))} */}
              </ul>
              <ul className="space-y-6">
                <li className="transition hover:text-color-primary">
                  <Link to="/terms" className="glo-link-style-footer">
                    الشروط والأحكام
                  </Link>
                </li>
                <li className="transition hover:text-color-primary">
                  <Link to="/privacy" className="glo-link-style-footer">
                    سياسة الخصوصية
                  </Link>
                </li>
                <li className="transition hover:text-color-primary">
                  <Link to="/about-us" className="glo-link-style-footer">
                    من نحن
                  </Link>
                </li>
                <li className="transition hover:text-color-primary">
                  <Link to="/blogs" className="glo-link-style-footer">
                    المدونات
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-col-3">
            <h4>اتصل بنا</h4>
            <div className="footer-col-3-content">
              <ul className="space-y-10">
                <li className="transition hover:text-color-primary">
                  <a
                    href={contactus?.address?.url}
                    // onClick={e => {
                    //   e.preventDefault();
                    //   setIsMapMod(true);
                    // }}
                    className="flex items-center gap-4"
                  >
                    <MdLocationOn />
                    {contactus?.address?.lable?.ar}
                  </a>
                </li>
                <li className="transition hover:text-color-primary">
                  <a href={contactus.email} className="flex items-center gap-4">
                    <AiFillMail />
                    {contactus?.email}
                  </a>
                </li>
                <li className="transition hover:text-color-primary">
                  <a href={contactus.phone} className="flex items-center gap-4">
                    <FiPhoneForwarded />
                    <span className="phone-num">{contactus?.phone}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
